export default __webpack_public_path__ + "static/touchSupport-b1048beec6d312cc60a382b457b520c5.gif";